import classNames from "classnames";
import { useEffect, useRef, useState } from "react";

import "./index.scss";
import { SearchDropDownWithBase } from "..";
import { IOnSearchUser } from "../../types/common.interface";

import DropDownLoading from "../DropDownLoading";
import convertStringToObjectProperty from "../../utils/convertStringToObjectProperty";

type Props = {
  size?: "medium" | "large";
  items: any[];
  label?: string;
  itemName: string;
  isRequired?: boolean;
  inputWidth?: number;
  defaultItem?: any;
  placeHolder: string;
  onSelectItem: (item: any) => void;
  searchPlaceHolder?: string;
  isSearch?: boolean;
  baseSearch: any;
  setSearchedValue: (event: any) => void;
  searchedValue: IOnSearchUser | undefined;
  isLoading?: boolean;
  selectedBaseSearch?: string;
};

const CustomDropDownSearch: React.FC<Props> = ({
  size = "medium",
  label,
  items,
  itemName,
  isRequired,
  inputWidth,
  defaultItem,
  placeHolder,
  onSelectItem,
  searchPlaceHolder,
  isSearch,
  baseSearch,
  setSearchedValue,
  searchedValue,
  isLoading,
  selectedBaseSearch,
}) => {
  const selectSearchRef = useRef<HTMLInputElement | null>(null);
  const [isActiveSearch, setIsActiveSearch] = useState(false);

  useEffect(() => {
    document.addEventListener("mousedown", (event: any) => {
      if (!selectSearchRef?.current?.contains(event.target)) {
        setIsActiveSearch(false);
      }
    });
  }, []);

  return (
    <section id="custom_dropdown" ref={selectSearchRef}>
      {label && (
        <div className="input-label">
          {label}
          {isRequired && (
            <i
              className={classNames(
                "fa-solid fa-star-of-life",
                "important-star"
              )}
            ></i>
          )}
        </div>
      )}
      <div
        className={classNames("dd-selection-container", `${size}`)}
        style={{ width: inputWidth }}
        onClick={(e) => setIsActiveSearch(!isActiveSearch)}
      >
        <div className="selection-value">
          <div className="remove-select-button">
            {defaultItem && defaultItem[itemName] !== null && (
              <i
                onClick={() => onSelectItem(null)}
                className="fa-solid fa-xmark"
              />
            )}
          </div>
          <div className="default-text">
            {defaultItem && defaultItem[itemName] !== null
              ? defaultItem[itemName]
              : placeHolder}
          </div>
        </div>
        {isActiveSearch ? (
          <i className="fa-solid fa-chevron-up"></i>
        ) : (
          <i className="fa-solid fa-chevron-down"></i>
        )}
      </div>

      {isActiveSearch && (
        <div className="dd-content-container">
          {isSearch && (
            <SearchDropDownWithBase
              icon="fa-solid fa-magnifying-glass"
              //defaultSearch={defaultSearch}
              size="medium-sd"
              onChangeSearch={(event: IOnSearchUser) => {
                setSearchedValue(event);
                //setDefaultSearch(event.searchedValue);
              }}
              defaultBaseSearch={
                searchedValue
                  ? baseSearch.find(
                      (item: any) => item.value === searchedValue?.base?.value
                    )
                  : baseSearch[0]
              }
              defaultSearch={searchedValue?.searchedValue}
              baseSearchItems={baseSearch}
            />
          )}
          <div className="items-container">
            {isLoading && <DropDownLoading />}

            {!isLoading &&
              items?.map((item, index) => (
                <div
                  key={`item-${index}`}
                  className={classNames(
                    defaultItem && defaultItem._id === item._id
                      ? "dd-content-selected"
                      : "dd-content-value"
                  )}
                  onClick={() => {
                    onSelectItem(item);
                    setIsActiveSearch(false);
                  }}
                >
                  <span>
                    {item[itemName]}
                    {
                      selectedBaseSearch &&
                        !selectedBaseSearch.split(".").includes(itemName) &&
                        searchedValue?.searchedValue !== "" &&
                        ""
                      // " (" +
                      //   convertStringToObjectProperty(
                      //     item,
                      //     selectedBaseSearch
                      //   ) +
                      //   ")"
                    }
                  </span>
                  {defaultItem && defaultItem?._id === item._id && (
                    <i className="fa-solid fa-check" />
                  )}
                </div>
              ))}
          </div>
        </div>
      )}
    </section>
  );
};

export default CustomDropDownSearch;
